import { getAllCountries } from "../services/countries.service";

export const getAllCountriesList = async (set) => {
    try {
        set({ isLoading: true });
        const response = await getAllCountries();

        if (response?.data) {
            set({
                list: response?.data?.data || [],
            }); // Save quote list to state
        } else {

            set({
                list: [],
            });
        }
    } catch (error) {
        console.error("Error fetching user:", error);
        // createAlert({
        //   type: "error",
        //   title: "Error",
        //   message: "An error occurred while fetching user.",
        //   status: true,
        // });
    } finally {
        set({ isLoading: false });
    }
};
